module.exports = __webpack_public_path__ + "media/img/pages/companies/syntegon-a85a084133c5019f22a02042b5792b43.png";